export const BANNER_HEIGHT = 36
